import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import SelectCards from 'components/Outdoor_Cameras/IN-9408_WQHD/Quick_Installation/SelectCards';
import NavButtons from 'components/Outdoor_Cameras/IN-9408_WQHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  SelectCards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};